import React from 'react';
import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const InviteStats = ({ earnings = '0.00', clients = 0 }) => {
  const navigate = useNavigate();
  
  return (
    <Box sx={{ width: '100%', mb: 4 }}>
      {/* 统计卡片容器 */}
      <Box 
        sx={{ 
          display: 'flex', 
          flexDirection: { xs: 'column', sm: 'row' }, 
          gap: 3,
          px: {  md: 0 }
        }}
      >
        {/* 总收益卡片 */}
        <Box 
          onClick={() => navigate('/campaigns/invitations/withdrawal-records')}
          sx={{
            flex: 1,
            p: 3,
            bgcolor: 'white',
            borderRadius: '8px',
            boxShadow: '0px 2px 12px rgba(0, 0, 0, 0.08)',
            cursor: 'pointer',
            transition: 'all 0.2s ease-in-out',
            '&:hover': {
              transform: 'translateY(-2px)',
              boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.12)',
            },
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start'
          }}
        >
          <Typography sx={{ 
            color: '#6B7280', 
            fontSize: '15px', 
            fontWeight: 500, 
            mb: 1.5,
            fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro", "Segoe UI", Roboto, sans-serif'
          }}>
            Total Earnings
          </Typography>
          <Typography sx={{ 
            fontSize: '32px', 
            fontWeight: 700, 
            color: '#000000', 
            mb: 2,
            fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro", "Segoe UI", Roboto, sans-serif'
          }}>
            ${earnings}
          </Typography>
          <Typography sx={{ 
            color: '#6B7280', 
            fontSize: '13px',
            mt: 'auto',
            fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro", "Segoe UI", Roboto, sans-serif'
          }}>
            Tap to view withdrawal history
          </Typography>
        </Box>
        
        {/* 总客户卡片 */}
        <Box 
          onClick={() => navigate('/campaigns/invitations/invitations-records')}
          sx={{
            flex: 1,
            p: 3,
            bgcolor: 'white',
            borderRadius: '8px',
            boxShadow: '0px 2px 12px rgba(0, 0, 0, 0.08)',
            cursor: 'pointer',
            transition: 'all 0.2s ease-in-out',
            '&:hover': {
              transform: 'translateY(-2px)',
              boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.12)',
            },
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start'
          }}
        >
          <Typography sx={{ 
            color: '#6B7280', 
            fontSize: '15px', 
            fontWeight: 500, 
            mb: 1.5,
            fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro", "Segoe UI", Roboto, sans-serif'
          }}>
            Total Clients
          </Typography>
          <Typography sx={{ 
            fontSize: '32px', 
            fontWeight: 700, 
            color: '#000000', 
            mb: 2,
            fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro", "Segoe UI", Roboto, sans-serif'
          }}>
            {clients}
          </Typography>
          <Typography sx={{ 
            color: '#6B7280', 
            fontSize: '13px',
            mt: 'auto',
            fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro", "Segoe UI", Roboto, sans-serif'
          }}>
            Tap to view referred clients
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default InviteStats; 